export enum BusinessPolicySetOperator {
  IN = 'IN',
  NOT_IN = 'NOT_IN',
}
